"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Separator = _interopRequireDefault(require("./Separator"));
var _Context = require("../Context");
var _resizeDetector = _interopRequireDefault(require("./resizeDetector"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class Link extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.handleLinkClick = () => () => {
      const {
        onClick,
        to
      } = this.props;
      if (onClick) {
        onClick(to);
      }
    };
    this.getLinkElement = () => {
      const {
        to,
        withoutPrefix,
        children,
        onClick,
        as
      } = this.props;
      const config = this.context;
      let href = `${config.appPrefix}${to}`;
      if (withoutPrefix || to.startsWith('http://') || to.startsWith('https://')) {
        href = to;
      }
      return _react.default.createElement(_styles.Link, {
        as: as,
        href: !onClick ? href : null,
        onClick: this.handleLinkClick()
      }, children);
    };
    this.handleElementRef = element => {
      this.element = element;
    };
  }
  componentDidMount() {
    if (this.element) {
      (0, _resizeDetector.default)('scroll').listenTo(this.element, element => {
        this.props.onResize(this.props.idx, element);
      });
    }
  }
  componentWillUnmount() {
    if (this.element) {
      (0, _resizeDetector.default)('scroll').removeAllListeners(this.element);
    }
  }
  render() {
    const {
      active,
      children
    } = this.props;
    const breadcrumb = _react.default.createElement("span", {
      ref: this.handleElementRef
    }, _react.default.createElement(_styles.Label, {
      text: _react.default.createElement(_styles.ActiveBreadcrumb, null, children),
      tooltip: children
    }));
    const linkedBreadcrumb = _react.default.createElement("span", {
      ref: this.handleElementRef
    }, _react.default.createElement(_styles.Label, {
      text: this.getLinkElement(),
      additionNode: _react.default.createElement(_Separator.default, null),
      tooltip: children
    }));
    return active ? breadcrumb : linkedBreadcrumb;
  }
}
Link.defaultProps = {
  active: false,
  onResize: () => {},
  withoutPrefix: false,
  as: _styles.Link
};
Link.contextType = _Context.ConfigContext;
var _default = exports.default = Link;